import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin( ScrollTrigger );


// Fade In Scroll Animation

const scrollAnimations = () => {
    // Add this class to the blocks you wish to fade in
    const fadeBlock = gsap.utils.toArray('.fadeblock');

    fadeBlock.forEach((box, i) => {
      const anim = gsap.fromTo(box, {autoAlpha: 0, y: 300}, {duration: 1.2, autoAlpha: 1, y: 0, ease: "Power1.easeOut"});

      ScrollTrigger.create({
        trigger: box,
        animation: anim,
        toggleActions: 'play none none none',
        once: true,
      });
    });
}

scrollAnimations();